//Use this class as a model for future services.
//No Custom Repository Class is required 

import { NotificationInfo } from "../entities/entities";
import { EntityManager, Repository } from "aurelia-orm";
import { autoinject, LogManager } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { AppEvents } from 'core/app-events';
import { ErrorHanderService } from 'data/service/error-handler-service';

@autoinject()
export class NotificationInfoService {

	logger = LogManager.getLogger('NotificationInfoService');


	getNew(): any {
		return this.repository.getNewEntity();
	}

	repository: Repository;
	constructor(private entityManager: EntityManager,
		private eventAggregator: EventAggregator,
		private errorHander: ErrorHanderService
	) {
		this.repository = this.entityManager.getRepository(NotificationInfo);
	}

	//Matches /api/tag on server.
	getNotifications() {
		return this.repository.find();
	}

	async getNotificationCount() {
		this.logger.info('getNotificationCount');

		try {
			const count = await this.repository.find('getNotificationCount', true);
			this.eventAggregator.publish(AppEvents.NOTIFICATION_COUNT_CHANGED, count);
		}
		catch (e) {
			this.errorHander.handleApiError('getNotificationCount()', e)
			//this.logger.info('error occured:' + e);
		}
		
	}

	restoreNotifications(numberToRestore: number): any {
		return this.repository.find("restore?numberToRestore=" + numberToRestore, true);
	}

	async markAllAsRead(first, last) {
		this.logger.info("Marking all as read");
		await this.repository.find(`markallasread?first=${first}&last=${last}`);
		this.getNotificationCount();
	}


	async clearAllAsRead() {
		this.logger.info("clear all as read");
		await this.repository.find(`clearallasread`);
		this.getNotificationCount();
	}

	async markAsRead(notificationId: number) {
		await this.repository.find(`markasread?id=${notificationId}`);
		this.getNotificationCount();
	}
	////Matches /api/tag/get-tags'
	//getTags() {
	//	return this.repository.find("get-tags");

	//}

}